/**
 * Tenant slug for legacy `/customer/consent/*` rollout fallback on platform chrome.
 */
import { useApiClient } from '../../shared/providers/AppDataProvider.js';
import { useCustomerSession } from '../../shared/session/CustomerSessionProvider.js';
import { useTenantCode } from '../../shared/tenant/TenantProvider.js';
import { isPlatformChromeTenant } from '../../app/platformChromeTenant.js';
import { usePlatformAccountMemberships } from '../account/accountApi.js';
import type { ConsentApiRolloutFallback } from './platformConsentApi.js';
import { resolveConsentApiFallbackTenantCode } from './resolveConsentApiFallbackTenantCode.js';

export function useConsentApiRolloutFallback(): ConsentApiRolloutFallback {
  const api = useApiClient();
  const tenantCode = useTenantCode();
  const { session } = useCustomerSession();
  const memberships = usePlatformAccountMemberships(
    session !== null && isPlatformChromeTenant(tenantCode),
  );
  return {
    api,
    fallbackTenantCode: resolveConsentApiFallbackTenantCode(
      tenantCode,
      memberships.data?.memberships,
    ),
  };
}
